import { Box, Button, SvgIcon, Typography } from '@mui/material';
import Alert from 'components/alerts/Alert';
import FileUpload from 'mdi-react/FileUploadIcon';
import ms from 'ms';
import { number, object, string } from 'prop-types';
import React, { useRef, useState } from 'react';
import { I18n } from 'utils/i18n';
import connector from './connector';

const alertInitialState = { isOpen: false };

const autoHideDuration = ms('10 seconds');

const Toolbar = ({ total, locale, actions, pendingImport = null }) => {
  const form = useRef();
  const fileInput = useRef();
  const [alert, setAlert] = useState(alertInitialState);
  const onClose = () => {
    setAlert(a => ({ ...a, ...alertInitialState }));
  };
  const onClick = () => {
    form.current.reset();
    fileInput.current.value = '';
    fileInput.current.click();
  };
  const handleChange = async event => {
    try {
      const file = event.target.files[0];
      await actions.employees.createImport(file);
    } catch (e) {
      setAlert({
        isOpen: true,
        variant: 'error',
        message: e.data?.message || I18n.t('AttachFile.Errors.Unexpected error'),
        caption: '',
      });
    }
  };
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        pr: 1,
        mb: 1,
      }}
    >
      <Typography component="div" sx={{ fontWeight: 600 }} variant="h4">
        {I18n.t('ImportsScene.ImportsTable.ImportsCount', { count: total.toLocaleString(locale) })}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flex: 1,
          justifyContent: 'flex-end',
        }}
      >
        {!pendingImport && (
          <Button component={Button} variant="contained" color="primary" onClick={onClick}>
            <SvgIcon sx={{ fontSize: 18, mr: '5px', color: theme => theme.palette.white }}>
              <FileUpload />
            </SvgIcon>
            {I18n.t('ImportsScene.ImportsTable.New import')}
          </Button>
        )}
        <Box component="form" sx={{ display: 'none' }} ref={form}>
          <input
            ref={fileInput}
            onChange={handleChange}
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            type="file"
          />
        </Box>
        <Alert
          isOpen={alert.isOpen}
          variant={alert.variant}
          onClose={onClose}
          label={I18n.t('ImportsScene.Import employees')}
          caption={alert.caption}
          autoHideDuration={autoHideDuration}
        >
          {alert.message}
        </Alert>
      </Box>
    </Box>
  );
};

Toolbar.propTypes = {
  total: number.isRequired,
  locale: string.isRequired,
  actions: object.isRequired,
  pendingImport: object,
};

export default connector(Toolbar);
